export default __webpack_public_path__ + "static/media/kerlighed.bbae633b.jpg";